import angular from 'angular';
import modalEditDelegationComponent from './modalEditDelegation.component';

let ModalEditDelegationModule = angular.module('ModalEditDelegation', [])

.component('modalEditDelegation', modalEditDelegationComponent)

.name;

export default ModalEditDelegationModule;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalEditDelegation/modalEditDelegation.js